import { statisticsService } from './statistics/statistics'

export const ALL_SERVICES = [
    statisticsService
]
